import "clsx";
import { a9 as fallback, T as escape_html, a0 as bind_props, a4 as ensure_array_like, Q as head, a6 as attr, P as pop, N as push } from "../../../../chunks/index.js";
import { D as DownloadButton } from "../../../../chunks/stores.js";
import { A as Animate } from "../../../../chunks/Animate.js";
import { S as SplitScreen, F as Features } from "../../../../chunks/Features.js";
import { F as FAQ } from "../../../../chunks/FAQ.js";
import { L as Loading } from "../../../../chunks/Loading.js";
import { P as Pricing } from "../../../../chunks/Pricing.js";
import { S as Separator } from "../../../../chunks/Separator.js";
const demo = {
  sources: {
    avif: "/_app/immutable/assets/glimmr-product-diagram.Cq95t_qJ.avif 2000w, /_app/immutable/assets/glimmr-product-diagram.Ci0SRHXy.avif 3999w",
    webp: "/_app/immutable/assets/glimmr-product-diagram.bstc1g0V.webp 2000w, /_app/immutable/assets/glimmr-product-diagram.DK3bvONO.webp 3999w",
    png: "/_app/immutable/assets/glimmr-product-diagram.BW_rD1Qh.png 2000w, /_app/immutable/assets/glimmr-product-diagram.DwL4o588.png 3999w"
  },
  img: {
    src: "/_app/immutable/assets/glimmr-product-diagram.DwL4o588.png",
    w: 3999,
    h: 4135
  }
};
function Detail($$payload, $$props) {
  let icon = fallback($$props["icon"], "");
  let title = fallback($$props["title"], "");
  let description = fallback($$props["description"], "");
  $$payload.out += `<div class="gap-4 flex flex-col w-full md:max-w-sm"><div class="p-4 rounded-full flex items-center justify-center bg-teal-900 text-teal-500 self-start"><span class="material-symbols-outlined">${escape_html(icon)}</span></div> <div class="flex flex-col gap-2"><h3 class="text-2xl font-display font-bold">${escape_html(title)}</h3> <span class="opacity-70 text-xl leading-relaxed">${escape_html(description)}</span></div></div>`;
  bind_props($$props, { icon, title, description });
}
function HeroBanner($$payload, $$props) {
  push();
  const detail = [
    {
      icon: "monitor",
      title: "Universal Support",
      description: "Supports direct display adjustments for 100K+ displays and displays."
    },
    {
      icon: "schedule",
      title: "Custom Schedules",
      description: "Set your brightness to adjust automatically, aligning with your daily workflow. Enjoy perfect lighting, from dawn till dusk."
    },
    {
      icon: "donut_small",
      title: "Shade Mode",
      description: "For old or incompatible displays, simulate brightness adjustments with a dark, translucent overlay."
    }
  ];
  const each_array_1 = ensure_array_like(detail);
  head($$payload, ($$payload2) => {
    $$payload2.out += `<link as="image"${attr("href", demo.img.src)} rel="preload">`;
  });
  $$payload.out += `<div class="section-container bg-white text-white relative z-0"><div class="section p-12 md:p-24 !py-36 !pt-44 bg-teal-950 rounded-3xl relative z-20 bg-repeat bg-contain"><div class="section relative z-10"><div class="text-center xl:text-left grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"><div class="space-y-12 z-10"><div class="space-y-8 text-shadow-2xl shadow-amber-100/10">`;
  Animate($$payload, {
    children: ($$payload2) => {
      $$payload2.out += `<div class="max-w-sm mx-auto lg:mx-0 lg:text-left text-center text-5xl md:text-6xl lg:text-7xl text-transparent font-display font-bold flex md:block justify-center"><h1 class="bg-clip-text bg-teal-50 capitalize leading-tight">Simplified Brightness Control</h1></div>`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> `;
  Animate($$payload, {
    delay: "0.1s",
    children: ($$payload2) => {
      $$payload2.out += `<span class="text-2xl md:text-4xl font-display opacity-80 lg:text-left">Easily adjust brightness for all your displays right from your
								system tray.</span>`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> `;
  Animate($$payload, {
    class: "flex gap-4 flex-wrap items-center justify-center lg:justify-start",
    delay: "0.2s",
    children: ($$payload2) => {
      DownloadButton($$payload2, {
        background: "dark",
        enableStoreDownload: true,
        primary: true,
        size: 2
      });
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> <div class="shrink-0 -order-1 lg:order-1 flex items-center justify-center w-full h-full relative"><div class="w-full max-w-lg flex items-center justify-center">`;
  Animate($$payload, {
    children: ($$payload2) => {
      if (typeof demo === "string") {
        $$payload2.out += "<!--[-->";
        $$payload2.out += `<img alt="demo" class="min-w-80" fetchpriority="high"${attr("src", demo.img.src)}${attr("width", demo.img.w)}${attr("height", demo.img.h)}>`;
      } else {
        $$payload2.out += "<!--[!-->";
        const each_array = ensure_array_like(Object.entries(demo.sources));
        $$payload2.out += `<picture><!--[-->`;
        for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
          let [format, srcset] = each_array[$$index];
          $$payload2.out += `<source${attr("srcset", srcset)}${attr("type", "image/" + format)}>`;
        }
        $$payload2.out += `<!--]--> <img alt="demo" class="min-w-80" fetchpriority="high"${attr("src", demo.img.src)}${attr("width", demo.img.w)}${attr("height", demo.img.h)}></picture>`;
      }
      $$payload2.out += `<!--]-->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></div></div></div> <div class="section flex flex-col justify-center md:flex-row flex-wrap gap-12 mt-24"><!--[-->`;
  for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
    let { icon, title, description } = each_array_1[i];
    Detail($$payload, { icon, title, description });
  }
  $$payload.out += `<!--]--></div></div></div>`;
  pop();
}
const happyCustomer = {
  sources: {
    avif: "/_app/immutable/assets/happy-customer.BW01dY1q.avif 1447w, /_app/immutable/assets/happy-customer.Bgbr-F2l.avif 2894w",
    webp: "/_app/immutable/assets/happy-customer.vlwcf1LJ.webp 1447w, /_app/immutable/assets/happy-customer.CZKf6ron.webp 2894w",
    png: "/_app/immutable/assets/happy-customer.WjlE6EBq.png 1447w, /_app/immutable/assets/happy-customer.DSLs2q3z.png 2894w"
  },
  img: {
    src: "/_app/immutable/assets/happy-customer.DSLs2q3z.png",
    w: 2894,
    h: 2374
  }
};
const mia = {
  sources: {
    avif: "/_app/immutable/assets/mia.CG_KUs6Z.avif 512w, /_app/immutable/assets/mia.DzHbpBH2.avif 1024w",
    webp: "/_app/immutable/assets/mia.CalEmRbm.webp 512w, /_app/immutable/assets/mia.xnm2BWrC.webp 1024w",
    png: "/_app/immutable/assets/mia.ZUI0E1b2.png 512w, /_app/immutable/assets/mia.BgF66sLt.png 1024w"
  },
  img: {
    src: "/_app/immutable/assets/mia.BgF66sLt.png",
    w: 1024,
    h: 1024
  }
};
const jordan = {
  sources: {
    avif: "/_app/immutable/assets/jordan.Do87jXQG.avif 512w, /_app/immutable/assets/jordan.CtY58nTc.avif 1024w",
    webp: "/_app/immutable/assets/jordan.C_pKr_yI.webp 512w, /_app/immutable/assets/jordan.BpRUq7cc.webp 1024w",
    png: "/_app/immutable/assets/jordan.D1Qy65W_.png 512w, /_app/immutable/assets/jordan.DP0UcEV0.png 1024w"
  },
  img: {
    src: "/_app/immutable/assets/jordan.DP0UcEV0.png",
    w: 1024,
    h: 1024
  }
};
const riley = {
  sources: {
    avif: "/_app/immutable/assets/riley.IMlA9w2h.avif 512w, /_app/immutable/assets/riley.QW0ldmS-.avif 1024w",
    webp: "/_app/immutable/assets/riley.CUg573Ee.webp 512w, /_app/immutable/assets/riley.BMBtDgwS.webp 1024w",
    png: "/_app/immutable/assets/riley.BU7EPpkw.png 512w, /_app/immutable/assets/riley.B2nP1pDL.png 1024w"
  },
  img: {
    src: "/_app/immutable/assets/riley.B2nP1pDL.png",
    w: 1024,
    h: 1024
  }
};
const alex = {
  sources: {
    avif: "/_app/immutable/assets/alex.CD5yvckK.avif 512w, /_app/immutable/assets/alex.BXPdtQmy.avif 1024w",
    webp: "/_app/immutable/assets/alex.Cooi0VnQ.webp 512w, /_app/immutable/assets/alex.Bpddat01.webp 1024w",
    png: "/_app/immutable/assets/alex.CA6DsdnK.png 512w, /_app/immutable/assets/alex.DbB6qq1a.png 1024w"
  },
  img: {
    src: "/_app/immutable/assets/alex.DbB6qq1a.png",
    w: 1024,
    h: 1024
  }
};
function Testimonial($$payload, $$props) {
  push();
  let message = fallback($$props["message"], "");
  let name = fallback($$props["name"], "");
  let title = fallback($$props["title"], "");
  let avatar = $$props["avatar"];
  $$payload.out += `<div class="bg-teal-900/10 rounded-3xl p-8 flex flex-col gap-8 h-full"><div class="flex-grow"><span class="material-symbols-outlined transform rotate-180 text-left self-start opacity-70" style="font-size: 3rem !important;">format_quote</span> <blockquote class="text-lg leading-relaxed">${escape_html(message)}</blockquote></div> <div class="flex items-center space-x-2"><div class="rounded-full overflow-hidden">`;
  if (typeof avatar === "string") {
    $$payload.out += "<!--[-->";
    $$payload.out += `<img height="48" loading="lazy"${attr("src", avatar.img.src)} width="48">`;
  } else {
    $$payload.out += "<!--[!-->";
    const each_array = ensure_array_like(Object.entries(avatar.sources));
    $$payload.out += `<picture><!--[-->`;
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let [format, srcset] = each_array[$$index];
      $$payload.out += `<source${attr("srcset", srcset)}${attr("type", "image/" + format)}>`;
    }
    $$payload.out += `<!--]--> <img height="48" loading="lazy"${attr("src", avatar.img.src)} width="48"></picture>`;
  }
  $$payload.out += `<!--]--></div> <div><div class="font-medium opacity-90">${escape_html(name)}</div> <div class="opacity-70">${escape_html(title)}</div></div></div></div>`;
  bind_props($$props, { message, name, title, avatar });
  pop();
}
function Testimonials($$payload, $$props) {
  push();
  $$payload.out += `<div class="w-full bg-white"><div class="section py-36">`;
  SplitScreen($$payload, {
    $$slots: {
      left: ($$payload2) => {
        $$payload2.out += `<div slot="left">`;
        if (typeof happyCustomer === "string") {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<img class="object-contain" loading="lazy"${attr("src", happyCustomer.img.src)}${attr("width", happyCustomer.img.w)}${attr("height", happyCustomer.img.h)}>`;
        } else {
          $$payload2.out += "<!--[!-->";
          const each_array = ensure_array_like(Object.entries(happyCustomer.sources));
          $$payload2.out += `<picture><!--[-->`;
          for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
            let [format, srcset] = each_array[$$index];
            $$payload2.out += `<source${attr("srcset", srcset)}${attr("type", "image/" + format)}>`;
          }
          $$payload2.out += `<!--]--> <img class="object-contain" loading="lazy"${attr("src", happyCustomer.img.src)}${attr("width", happyCustomer.img.w)}${attr("height", happyCustomer.img.h)}></picture>`;
        }
        $$payload2.out += `<!--]--></div>`;
      },
      right: ($$payload2) => {
        $$payload2.out += `<div class="space-y-4 md:space-y-8" slot="right"><div class="gap-2"><span class="text-base/7 font-semibold text-teal-600 font-display">Testimonials</span> <h2 class="text-6xl font-bold font-display text-teal-900">See What Our Customers Have to Say</h2></div> <div class="grid grid-cols-1 xl:grid-cols-2 grid-rows-2 gap-10 gap-y-16 pt-12">`;
        Testimonial($$payload2, {
          avatar: mia,
          message: "Before Glimmr, adjusting my display's brightness was a daily hassle, especially when dealing with the tiny buttons on the back of my screen. Now, I can easily manage everything from my desktop. It's not just convenient; it's a relief.",
          name: "Mia T.",
          title: "Digital Marketing Manager"
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          avatar: jordan,
          message: "The custom schedules feature in Glimmr has been a game-changer for me. I love how my screen automatically dims as the sun sets, making those long writing sessions less of a strain on my eyes. It's such a smart, user-friendly tool.",
          name: "Jordan M.",
          title: "Aspiring Writer"
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          avatar: riley,
          message: "I'm all about aesthetics, and Glimmr is not only a lifesaver for managing my dual displays but it's also beautifully designed. It fits perfectly into my workflow and my desktop setup. Finally, an app that gets it right.",
          name: "Riley S.",
          title: "Graphic Designer"
        });
        $$payload2.out += `<!----> `;
        Testimonial($$payload2, {
          avatar: alex,
          message: "Dealing with multiple displays used to mean constantly fiddling with settings to get a uniform look. With Glimmr, it's a one-time setup, and everything is synchronized perfectly. It's such a simple solution to what was an ongoing frustration.",
          name: "Alex D.",
          title: "IT Professional"
        });
        $$payload2.out += `<!----></div></div>`;
      }
    }
  });
  $$payload.out += `<!----></div></div>`;
  pop();
}
function _page($$payload) {
  Loading($$payload);
  $$payload.out += `<!----> `;
  HeroBanner($$payload);
  $$payload.out += `<!----> `;
  Features($$payload);
  $$payload.out += `<!----> `;
  Testimonials($$payload);
  $$payload.out += `<!----> `;
  Separator($$payload, {});
  $$payload.out += `<!----> `;
  Pricing($$payload);
  $$payload.out += `<!----> `;
  Separator($$payload, {});
  $$payload.out += `<!----> `;
  FAQ($$payload);
  $$payload.out += `<!---->`;
}
export {
  _page as default
};
